import { UseTranslationResponse } from "react-i18next";

interface IResolveSaveLabelArguments {
  isPreviewStep: boolean;
  isComplete: boolean;
  /** What the run does on commit - a create panel creates, an edit panel saves. */
  commitLabelKey: string;
  t: UseTranslationResponse<"translations", undefined>["t"];
}

export const resolveSaveLabel = ({
  isPreviewStep,
  isComplete,
  commitLabelKey,
  t,
}: IResolveSaveLabelArguments): string => {
  switch (true) {
    case isComplete:
      return t("general.CLOSE");
    case isPreviewStep:
      return t(commitLabelKey);
    default:
      return t("general.NEXT");
  }
};

interface IResolveCancelLabelArguments {
  isPreviewStep: boolean;
  t: UseTranslationResponse<"translations", undefined>["t"];
}

export const resolveCancelLabel = ({
  isPreviewStep,
  t,
}: IResolveCancelLabelArguments): string => {
  return isPreviewStep ? t("general.BACK") : t("general.CANCEL");
};
